module.exports = __webpack_public_path__ + "static/media/merge.003a3cb0.png";